/** @jsxImportSource @emotion/react */

import { css } from "@emotion/react";

interface BackdropProps {
  isOpen: boolean;
  setIsOpen: (arg: boolean) => void;
}

function Backdrop({ isOpen, setIsOpen }: BackdropProps) {
  return (
    <div
      id="select-backdrop"
      css={css`
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 10;
        display: ${isOpen ? "block" : "none"};
      `}
      onClick={() => setIsOpen(false)}
    ></div>
  );
}

export default Backdrop;
